"use client";

import cnBind from "classnames/bind";
import { useTranslation } from "react-i18next";

import { persistSiteLocale, type SiteLocale } from "@/i18n/client";

import styles from "./LanguageSwitcher.module.scss";

const cx = cnBind.bind(styles);

type Props = {
    className?: string;
    variant?: "light" | "dark";
};

export function LanguageSwitcher({ className, variant = "light" }: Props) {
    const { i18n } = useTranslation("common");
    const locale = (i18n.language?.startsWith("en") ? "en" : "ru") as SiteLocale;

    const setLocale = (next: SiteLocale) => {
        if (next === locale) return;
        void i18n.changeLanguage(next);
        persistSiteLocale(next);
    };

    return (
        <div
            className={cx("root", variant === "dark" && "rootDark", className)}
            role="group"
            aria-label="Language"
        >
            <button
                type="button"
                className={cx("btn", locale === "ru" && "active")}
                onClick={() => setLocale("ru")}
                aria-pressed={locale === "ru"}
            >
                RU
            </button>
            <button
                type="button"
                className={cx("btn", locale === "en" && "active")}
                onClick={() => setLocale("en")}
                aria-pressed={locale === "en"}
            >
                EN
            </button>
        </div>
    );
}
